import React from "react";
import check from "/check-icon.svg";
import styles from "./RewardSquare.module.css";
import { Reward } from "../../Components/Reward/Reward";

export interface Reward {
  type: string;
  amount: number;
}

export interface TaskDetails {
  current_day: boolean;
}

export interface Task {
  id: number;
  slug: string;
  name: string;
  type: string;
  target_progress: number;
  icon: string;
  details: TaskDetails;
  rewards: Reward[];
  status: string;
  partner: string | null;
  user_progress: number;
}

export interface DailyBonusData {
  task_group_id: number;
  slug: string;
  name: string;
  description: string;
  icon_url: string;
  banner_url: string;
  tasks: Task[];
  completed_tasks: number;
  total_tasks: number;
  type: string;
  rewards: Reward[];
}

export interface RewardSquareProps {
  rew: Task;
  index: number;
  data: DailyBonusData;
}

const RewardSquare: React.FC<RewardSquareProps> = ({ rew, index, data }) => {
  const getSquareClass = () => {
    if (rew.status === "CLAIMED" && rew.details.current_day === false) {
      return styles.dailySquareClaimed;
    }

    if (rew.details.current_day) {
      return styles.dailySquareNext;
    }

    return styles.dailySquare;
  };

  const getRewardType = (type: string): 'dc' | 'ticket' | 'character' | 'USDT' => {
    switch (type.toLowerCase()) {
      case 'dc':
        return 'dc';
      case 'tickets':
        return 'ticket';
      case 'usdt':
        return 'USDT';
      case 'character':
        return 'character';
      default:
        return 'dc';
    }
  };

  return (
    <div
      className={`
      ${getSquareClass()}
      ${
        index ===
        (data.tasks.length % 2 === 0
          ? data.tasks.length
          : data.tasks.length - 1)
          ? styles.lastSquare
          : ""
      }
    `}
      key={rew.id}
    >
      <p className={styles.dailyDay}>День {index + 1}</p>

      {rew.status === "CLAIMED" ? (
        <>
          <div className={styles.claimedAlreadyContent}>
            <div className={styles.claimedAlready}>Получено</div>
            <img src={check} alt="" />
          </div>
        </>
      ) : (
        <div className={styles.dailySquareReward}>
          {rew.rewards.length === 1 ? (
            <>
              {rew.rewards.map((item) => (
                <Reward
                  key={item.type}
                  type={getRewardType(item.type)}
                  amount={item.amount}
                />
              ))}
            </>
          ) : (
            <div className={styles.rewardCurrencies}>
              {rew.rewards.map((item) => (
                <Reward
                  key={item.type}
                  type={getRewardType(item.type)}
                  amount={item.amount}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RewardSquare;
